@import 'styles/variables';

.deleteIcon {
  color: var(--negative-50);
}
